var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.options.textSizeClass]},[_vm._v(" کد ملی: "+_vm._s(_vm.nationalCode)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }